import React from 'react'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../common/SafeIcon'

const { FiAlertTriangle, FiRefreshCw } = FiIcons

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
    
    // Bind methods in constructor
    this.handleReload = this.handleReload.bind(this)
    this.handleGoHome = this.handleGoHome.bind(this)
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo
    })
    
    // Log error to console in development
    if (process.env.NODE_ENV === 'development') {
      console.error('Error caught by boundary:', error, errorInfo)
    }
    
    // In production, you might want to log to an error reporting service
    // logErrorToService(error, errorInfo)
  }

  handleReload() {
    window.location.reload()
  }

  handleGoHome() {
    window.location.href = '#/'
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-black text-white flex items-center justify-center p-4">
          <div className="max-w-md w-full text-center">
            <div className="mb-8">
              <SafeIcon icon={FiAlertTriangle} className="w-16 h-16 text-red-600 mx-auto mb-4" />
              <h1 className="text-2xl font-bold mb-2">Something Went BAD</h1>
              <p className="text-gray-400 mb-6">
                Even rebels encounter unexpected obstacles. Our bad.
              </p>
            </div>

            <div className="space-y-4">
              <button
                onClick={this.handleReload}
                className="w-full bg-red-600 hover:bg-red-700 text-white px-6 py-3 font-bold transition-all duration-300 flex items-center justify-center space-x-2"
              >
                <SafeIcon icon={FiRefreshCw} className="w-5 h-5" />
                <span>Reload Page</span>
              </button>
              
              <button
                onClick={this.handleGoHome}
                className="w-full bg-transparent border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white px-6 py-3 font-bold transition-all duration-300"
              >
                Go Home
              </button>
            </div>

            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details className="mt-8 text-left">
                <summary className="cursor-pointer text-gray-400 hover:text-white">
                  Technical Details (Development)
                </summary>
                <div className="mt-4 p-4 bg-zinc-900 rounded border border-gray-800 text-sm font-mono text-gray-300 overflow-auto">
                  <div className="mb-2">
                    <strong>Error:</strong> {this.state.error.toString()}
                  </div>
                  <div>
                    <strong>Stack:</strong>
                    <pre className="whitespace-pre-wrap text-xs mt-1">
                      {this.state.errorInfo.componentStack}
                    </pre>
                  </div>
                </div>
              </details>
            )}
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary